import type { AiInsightsAnalyticsEventProperties } from './AiInsightsAnalyticsEvents';
import useTrackAiInsightsEvent from './useTrackAiInsightsEvent';

const useTrackAiInsightsPageEvent = () => useTrackAiInsightsEvent<AiInsightsAnalyticsEventProperties>();

export default useTrackAiInsightsPageEvent;
